import PropTypes from 'prop-types'
import { useState } from 'react'
import { Table, Typography, Tag, Tooltip } from 'antd'
import { Link, generatePath } from 'react-router-dom'
import { CheckOutlined, StopOutlined } from '@ant-design/icons'
import { colours } from '@qflow/theme'

import { Flag } from 'admin/lib/Icons/Flag'
import * as ROUTES from 'admin/routes'
import moment from 'moment'
import { CloseOutModal } from './CloseOutModal'

export function ProjectList({ projects, accountId }) {
  projects.map(project => (project.accountId = accountId))

  const [closeOutProject, setCloseOutProject] = useState(null)

  const columns = [
    {
      title: 'Project Name',
      dataIndex: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      width: '15%'
    },
    {
      title: 'ID',
      dataIndex: 'projectId',
      sorter: (a, b) => a.projectId.localeCompare(b.projectId),
      width: '12.5%'
    },
    {
      title: 'Pro',
      dataIndex: 'isProLicence',
      width: '0px',

      align: 'center',
      render: isProLicence => {
        return isProLicence ? (
          <CheckOutlined
            style={{ color: colours.GREEN, fontSize: '1.25rem' }}
          />
        ) : null
      }
    },
    {
      title: 'Alerts',
      dataIndex: 'isAlertsEnabled',
      width: '0px',
      align: 'center',
      render: isAlertsEnabled => {
        return isAlertsEnabled ? (
          <CheckOutlined
            style={{ color: colours.GREEN, fontSize: '1.25rem' }}
          />
        ) : null
      }
    },
    {
      title: 'Closed Out',
      dataIndex: 'isClosedOut',
      width: '0px',
      align: 'center',
      render: isClosedOut => {
        return isClosedOut ? (
          <Tooltip title="The Project is Closed Out and new tickets will not arrive. NOTE: Currently there is no prevention of new Connections being created.">
            <StopOutlined style={{ color: colours.RED, fontSize: '1.25rem' }} />
          </Tooltip>
        ) : null
      }
    },
    {
      title: 'Creation Date',
      dataIndex: 'createdAt',
      width: '10rem',
      render: createdAt => {
        return (
          <Typography.Text>
            {moment(createdAt).local().format('DD/MM/YYYY HH:mm')}
          </Typography.Text>
        )
      }
    },
    {
      title: 'Country',
      dataIndex: 'country',
      sorter: (a, b) => a.country.localeCompare(b.country),
      width: '9%',
      render: country => {
        return <Typography.Text>{country}</Typography.Text>
      }
    },
    {
      title: '',
      dataIndex: 'country',
      width: '0px',
      render: country => {
        return (
          <Flag
            country={country}
            style={{ width: '28px', margin: '0 -16px -2px' }}
          />
        )
      }
    },
    {
      title: 'Time Zone',
      dataIndex: 'timeZone',
      sorter: (a, b) => a.timeZone.localeCompare(b.timeZone),
      width: '9%'
    },
    {
      title: 'Modules',
      dataIndex: 'moduleTags',
      render: modules =>
        modules?.map(module =>
          module.isTagged ? (
            <Tag
              key={module.moduleTagDefinitionId}
              style={{ margin: '.25rem 0' }}
            >
              {module.moduleTagDefinitionName}{' '}
            </Tag>
          ) : (
            ' '
          )
        )
    },
    {
      title: 'Links',
      key: 'links',
      width: '14rem',
      render: project => (
        <div style={{ margin: '0 -16px' }}>
          <Typography.Text
            style={{ lineHeight: '1.25', margin: '2px', display: 'block' }}
          >
            <Link
              to={generatePath(ROUTES.CONNECTIONS.LIST, {
                accountId: project.accountId,
                projectId: project.projectId
              })}
            >
              Connections
            </Link>
          </Typography.Text>
          <Typography.Text
            style={{ lineHeight: '1.25', margin: '2px', display: 'block' }}
          >
            <Link
              to={generatePath(ROUTES.NOTIFICATIONS.LIST, {
                accountId: project.accountId,
                projectId: project.projectId
              })}
            >
              Notifications
            </Link>
          </Typography.Text>
          <Typography.Text
            style={{ lineHeight: '1.25', margin: '2px', display: 'block' }}
          >
            <Link
              to={generatePath(ROUTES.SMART_WASTE.EDIT, {
                accountId: project.accountId,
                projectId: project.projectId
              })}
            >
              SmartWaste
            </Link>
          </Typography.Text>
        </div>
      )
    },
    {
      title: 'Edit',
      key: 'edit',
      width: '7rem',
      render: project => (
        <div style={{ margin: '0' }}>
          <Typography.Text style={{ lineHeight: '1.5', display: 'block' }}>
            <Link
              to={generatePath(ROUTES.PROJECTS.EDIT, {
                accountId: project.accountId,
                projectId: project.projectId
              })}
            >
              Edit
            </Link>
          </Typography.Text>
          <Typography.Text
            style={{
              lineHeight: '1.5',
              marginTop: '1em',
              display: 'block'
            }}
          >
            <Link
              style={{ color: colours.RED }}
              onClick={() => {
                setCloseOutProject(project)
              }}
            >
              Close Out
            </Link>
          </Typography.Text>
        </div>
      )
    }
  ]
  return (
    <>
      <Table
        columns={columns}
        dataSource={projects}
        rowKey={row => row.projectId}
        pagination={false}
        style={{ width: '100%', margin: '3rem 1rem' }}
      />
      {closeOutProject && (
        <CloseOutModal
          accountId={accountId}
          project={closeOutProject}
          onCancel={() => setCloseOutProject(null)}
          onSuccess={() => window.location.reload()}
        />
      )}
    </>
  )
}

ProjectList.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.object),
  accountId: PropTypes.string.isRequired
}
